export default __webpack_public_path__ + "static/media/scenario-a-plan.b5bf34b8.png";